import {
  brandSpecificStaticText,
  staticText,
} from '../../utils/translations/staticText';

/**
 * Panel chrome only. Option labels are authored per language version in Strapi:
 * a built-in one would have to name a direction the measure does not own.

 */
const BASE = staticText({
  /* CMS-1871 R11 / BRD FR-3.5. Copy supplied by Genevieve, 17 Sep.
     `{count}` is the repo's placeholder idiom; English needs three forms and
     Chinese two, because it does not inflect for plural.
     ⚠️ The Chinese singular for credit cards is inferred from her pattern, not
     her literal text: her table merged the Chinese cells across the count rows.
     Confirm with her before this ships (noted on CMS-2002). */
  sort_and_filter_results_pl_one: {
    _: '1 personal loan found',
    zh: '共 1 個私人貸款計劃',
  },
  sort_and_filter_results_pl_many: {
    _: '{count} personal loans found',
    zh: '共 {count} 個私人貸款計劃',
  },
  sort_and_filter_results_pl_none: {
    _: 'No personal loans found',
    zh: '沒有符合篩選條件的私人貸款計劃',
  },
  sort_and_filter_results_ti_one: {
    _: '1 plan found',
    zh: '共 1 個計劃',
  },
  sort_and_filter_results_ti_many: {
    _: '{count} plans found',
    zh: '共 {count} 個計劃',
  },
  sort_and_filter_results_ti_none: {
    _: 'No plans found',
    zh: '沒有符合篩選條件的計劃',
  },
  sort_and_filter_results_cc_one: {
    _: '1 credit card found',
    zh: '共 1 張信用卡',
  },
  sort_and_filter_results_cc_many: {
    _: '{count} credit cards found',
    zh: '共 {count} 張信用卡',
  },
  sort_and_filter_results_cc_none: {
    _: 'No credit cards found',
    zh: '沒有符合篩選條件的信用卡',
  },
  // The name is the editor's option label, so this is a prefix, not a sentence.
  sort_and_filter_sorted_by: {
    _: 'Sorted by: {name}',
    zh: '排序 {name}',
  },
  sort_and_filter_panel_title: {
    _: 'Sort and Filter',
    zh: '排序篩選',
  },
  // CMS-2072: the button on the personal loan bar, which names the market's own
  // string rather than the editor's panel title.
  sort_and_filter_all_filters: {
    _: 'All Filters',
    zh: '所有篩選',
  },
  sort_and_filter_sort_by: {
    _: 'Sort By',
    zh: '排序',
  },
  sort_and_filter_clear_all: {
    _: 'Clear All',
    zh: '重設',
  },
  // R5.2: dismisses the overlay and commits nothing — filters already applied.
  sort_and_filter_apply: {
    _: 'Apply',
    zh: '套用',
  },
  // The chip's visible text is the value; its accessible name has to say that
  // pressing it removes the filter.
  sort_and_filter_remove_filter: {
    _: 'Remove filter',
    zh: '移除篩選',
  },
  // R8: the empty state names what happened rather than showing a bare blank.
  sort_and_filter_no_results_title: {
    _: 'No products match your filters',
    zh: '沒有符合篩選條件的產品',
  },
  sort_and_filter_no_results_body: {
    _: 'Try removing a filter to see more results.',
    zh: '請嘗試移除篩選條件以查看更多結果。',
  },
  // Fallbacks for a filter group's own `collapsed_label` / `expanded_label`,
  // which are optional in Strapi (CMS-1542): a group that leaves them empty
  // renders these rather than an unlabelled control.
  sort_and_filter_show_all: {
    _: '+ Show all',
    zh: '+ 顯示全部',
  },
  sort_and_filter_show_less: {
    _: 'Show less',
    zh: '顯示較少',
  },
  // The accessible name of the overlays' back arrow, which closes them.
  sort_and_filter_close: {
    _: 'Close',
    zh: '關閉',
  },
});

/* Taiwan names the product differently: 信用貸款方案 rather than Hong Kong's
   私人貸款計劃. Genevieve's table, 17 Sep — the only string here that varies by
   brand rather than by language. */
const MONEY101 = staticText({
  sort_and_filter_results_pl_one: {
    _: '1 personal loan found',
    zh: '共 1 個信用貸款方案',
  },
  sort_and_filter_results_pl_many: {
    _: '{count} personal loans found',
    zh: '共 {count} 個信用貸款方案',
  },
  sort_and_filter_results_pl_none: {
    _: 'No personal loans found',
    zh: '沒有符合篩選條件的信用貸款方案',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: BASE,
  money101: MONEY101,
});

export type SortAndFilterPanelTranslations = typeof TRANSLATIONS;
